import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

Vue.mixin({
	methods: {
		getDayName( Date ) {
			switch(Date.getDay()) {
				case 0 : return 'Sunday';
				case 1 : return 'Monday';
				case 2 : return 'Tuesday';
				case 3 : return 'Wednesday';
				case 4 : return 'Thursday';
				case 5 : return 'Friday';
				case 6 : return 'Saturday';
			}
			return false;
		},
		getMonthName( Date ) {
			switch( Date.getMonth()) {
				case 0 : return 'January';
				case 1 : return 'February';
				case 2 : return 'March';
				case 3 : return 'April';
				case 4 : return 'May';
				case 5 : return 'June';
				case 6 : return 'July';
				case 7 : return 'August';
				case 8 : return 'September';
				case 9 : return 'October';
				case 10 : return 'November';
				case 11 : return 'December';
			}
		},
		getInitialUserFieldsState(){
			return {
				senderInformation: {
					name: '',
					email: '',
					phone: '',
					senderType: 'personal',
					department: {
						orgNumber: '',
						departmentName: '',
					},
					address: {
						country: 'United States',
						state: 'ME',
						city: 'Lewiston',
						zip: '04240',
						zip4: '',
						street: '',
					},
				},
				packageInformation: {
					name: '',
					email: '',
					phone: '',
					address: {
						country: 'United States',
						state: '',
						city: '',
						zip: '',
						zip4: '',
						street: '',
					},
				},
				packageContents: '',
			};
		},
	}
});

Vue.filter('nl2br', function(str){
	return str.replace("\n", '<br>');
});
Vue.filter('pad', function(str, padLength=2, padChar='0', side='left'){
	var numeric = str + "";
	if( numeric.length >= padLength )
		return numeric;
	while( numeric.length < padLength ){
		if( side=='left' )
			numeric = padChar + numeric;
		else
			numeric += padChar;
	}

	return numeric;
});

new Vue({
  render: h => h(App),
}).$mount('#app')
